import {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from "react";

interface OrgContextValue {
  orgId: string;
  setOrgId: (id: string) => void;
}

const OrgContext = createContext<OrgContextValue | null>(null);

const DEFAULT_ORG_ID = import.meta.env.VITE_DEFAULT_ORG_ID || "1";
const ORG_STORAGE_KEY = "orgId";

function getInitialOrgId(): string {
  const stored = localStorage.getItem(ORG_STORAGE_KEY);
  return stored || DEFAULT_ORG_ID;
}

interface OrgProviderProps {
  children: ReactNode;
}

export function OrgProvider({ children }: OrgProviderProps) {
  const [orgId, setOrgIdState] = useState<string>(getInitialOrgId);

  const setOrgId = useCallback((id: string) => {
    localStorage.setItem(ORG_STORAGE_KEY, id);
    setOrgIdState(id);
  }, []);

  return (
    <OrgContext.Provider value={{ orgId, setOrgId }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg(): OrgContextValue {
  const context = useContext(OrgContext);
  if (!context) {
    throw new Error("useOrg must be used within an OrgProvider");
  }
  return context;
}
